import React from 'react'
import ArrowLayer from './ArrowLayer'

const IceDrift = () => {
    return (
        <ArrowLayer
            id='IceDriftVector'
            datetimeId='IceDrift'
            sourceLayer='ice-drift'  
            authId='IceDrift'
            maxzoom={10}
        />
    )
}

export default IceDrift



// WEBPACK FOOTER //
// ./src/layers/IceDriftVector.js